import React from 'react'


export default function Dashboard() {
    return (
        <>

            <div className='header'>
                <h1 className='header-title'>Dashboard</h1>
                {/* <p className='header-subtitle'>You have 24 new messages and 5 new notifications.</p> */}
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body mt-3 mb-6">
                            Bem-vindo!
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row">
                <div className="col-sm-3">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Sales Today</h5>
                                </div>

                                <div className="col-auto">
                                    <div className="avatar">
                                        <div className="avatar-title rounded-circle bg-primary-dark">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="feather feather-truck align-middle"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h1 className="display-5 mt-1 mb-3">2.562</h1>
                            <div className="mb-0">
                                <span className="text-danger"> <i className="mdi mdi-arrow-bottom-right"></i> -2.65% </span>
                                Less sales than usual
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-3">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Visitors Today</h5>
                                </div>

                                <div className="col-auto">
                                    <div className="avatar">
                                        <div className="avatar-title rounded-circle bg-primary-dark">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="feather feather-users align-middle"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h1 className="display-5 mt-1 mb-3">17.212</h1>
                            <div className="mb-0">
                                <span className="text-success"> <i className="mdi mdi-arrow-bottom-right"></i> 5.50% </span>
                                More visitors than usual
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-3">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Total Earnings</h5>
                                </div>

                                <div className="col-auto">
                                    <div className="avatar">
                                        <div className="avatar-title rounded-circle bg-primary-dark">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="feather feather-dollar-sign align-middle"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h1 className="display-5 mt-1 mb-3">$24.300</h1>
                            <div className="mb-0">
                                <span className="text-success"> <i className="mdi mdi-arrow-bottom-right"></i> 8.35% </span>
                                More earnings than usual
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-3">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Pending Orders</h5>
                                </div>

                                <div className="col-auto">
                                    <div className="avatar">
                                        <div className="avatar-title rounded-circle bg-primary-dark">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="feather feather-shopping-cart align-middle"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h1 className="display-5 mt-1 mb-3">43</h1>
                            <div className="mb-0">
                                <span className="text-danger"> <i className="mdi mdi-arrow-bottom-right"></i> -4.25% </span>
                                Less orders than usual
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

        </>
    )
}